import { IUserInfoResponse } from '../../repositories/UserInfoRepository';

export class UserInfo {
    public isSignedIn: boolean;
    public id: string;
    public sessionId?: string;

    public static fromJson(data: IUserInfoResponse): UserInfo {
        const user = new UserInfo();
        user.isSignedIn = data.signed_in;
        user.id = data.user_id;
        user.sessionId = data.session_id;

        return user;
    }

    get userId() {
        return this.isSignedIn && this.id;
    }
}
